<template>
    <div>
        <div class="top">
            <div class="top-header">
            </div>

            <div class="container" v-if="orderInfo">
                <div class="header">
                    <h3>{{orderInfo.companyName}}</h3>
                    <p>{{orderInfo.companyBatchName}}</p>
                </div>

                <div class="card employee-wrapper">
                    <div class="emp-top">
                        <span class="emp-name">{{orderInfo.name}}</span><span
                            class="emp-mobile">{{orderInfo.mobile|mask("phone")}}</span>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">证件号码</div>
                        <div class="cell-value">{{orderInfo.idcard|mask("idcard")}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">体检编号</div>
                        <div class="cell-value">{{orderInfo.examNo}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">套餐分组</div>
                        <div class="cell-value" @click="showGroupItems = true">{{orderInfo.groupName}}
                            <span style="float:right;color:#1496f1;">共{{groupItemsCount}}项
                                <van-icon name="arrow" /></span></div>
                    </div>
                </div>
                <div class="card date-picker-wrapper">
                    <p class="title">请选择体检日期</p>
                    <ul>
                        <li class="date-item-wrapper" v-for="(dateItem,i) in schedule">
                            <div class="date-list">
                                <div class="date-item">{{dateItem.orderDate}} {{dateItem.dayName}}
                                </div>
                                <!-- <div class="date--disable"
                                    v-if="dateItem.is_open == '0' || dateItem.is_full==1 || !dateItem.orderable">
                                    {{dateItem.reason}}
                                </div> -->
                                <div class="btn-date btn-date--noselect" @click="selectDate(i,dateItem)">选择</div>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
        <!-- <div class="fixed-footer" style="text-align:center">
            <div style="max-width:480px; padding: 0 16px;">
                <van-button type="info" size="large" round style="margin:8px 0;" :disabled="orderDisable"
                    @click="submitOrder()">确定预约
                </van-button>
            </div>
        </div> -->

        <!-- 选择日期组件，弹窗显示 -->
        <van-popup v-model="showTimeRange" round position="bottom">
            <div class="time-range-wrapper">
                <p>请选择时间段</p>
                <ul class="timeRanges" v-if="timeRanges && timeRanges.length>0">
                    <li v-for="tr in timeRanges" class="time-item"
                        :class="{'time-item--disabled':tr.limitNum==0 || tr.limitNum<=tr.orderNum ,'time-item--selected': tr == orderTime}"
                        @click="setOrderTime(tr)">
                        {{tr.name}}
                        <p v-if="tr.limitNum==0 || tr.limitNum<=tr.orderNum">不可预约</p>
                        <p v-else>可预约 （{{tr.orderNum}}/{{tr.limitNum}}）</p>
                    </li>
                </ul>
                <div class="timeRanges--empty" v-else>
                    <span>无可用的时间段</span>
                </div>
                <van-button size="large" type="info" @click="submitOrder()" :disabled="!orderTime">提交预约</van-button>
            </div>
        </van-popup>

        <!-- 显示分组明细项目 -->
        <van-popup v-model="showGroupItems" round position="bottom">
            <div class="group-items-wrapper">
                <p class="group-items-header">套餐分组项目</p>
                <div v-for="group in groupItems">
                    <div class="group-title">{{group.title}}</div>
                    <ul class="item-list">
                        <li v-for="(item,i) in group.items" class="item-detail">
                            <p class="item-name">{{item.itemName}}</p>
                            <p class="item-mean">{{item.itemMeanning}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<style lang="less" scoped>
    .top {
        width: 100%;
        position: relative;
        z-index: 0;
        overflow: hidden;
        color: #ffffff;
    }

    .top::before {
        content: '';
        width: 120%;
        height: 160px;
        position: absolute;
        left: -10%; //椭圆左边隐藏10%，右边隐藏10%
        top: 0;
        border-radius: 0 0 50% 50%; //左上角，右上角，右下角，左下角
        background: #1496f1;
        z-index: -1;
    }

    .container {
        width: calc(100% - 20px);
        min-height: 100vh;
        top: 0;
        left: 0;
        padding: 10px;
        padding-bottom: 60px;

        .header {
            color: #ffffff;

            h3 {
                line-height: 36px;
                font-size: 20px;
                font-weight: 600;
            }

            p {
                font-size: 14px;
            }
        }

        .card {
            margin-top: 16px;
            background: #ffffff;
            border-radius: 8px;
            color: rgba(0, 0, 0, 0.75);
            padding: 16px;
        }

        .employee-wrapper {
            .emp-top {
                margin-bottom: 10px;

                .emp-name {
                    font-size: 18px;

                }

                .emp-mobile {
                    margin-left: 16px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.45)
                }
            }


            .info-cell {
                display: flex;
                padding: 10px 0;
                font-size: 14px;

                .cell-text {
                    width: 100px;
                    color: rgba(0, 0, 0, 0.45);
                }

                .cell-value {
                    flex: 1;
                    cursor: pointer;
                }
            }
        }

        .date-picker-wrapper {
            .title {
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 8px;
            }

            .date-item-wrapper {
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            }

            .date-list {
                display: flex;
                align-items: center;
                padding: 16px 0;

                .date-item {
                    flex: 1;
                    line-height: 24px;
                    font-size: 14px;
                    //font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                }


                .date-tag {
                    margin-right: 20px;
                    background: rgb(255, 232, 210);
                    color: rgb(201, 74, 1);
                    font-size: 12px;
                    font-weight: 400;
                    padding: 4px;
                    border-radius: 3px;
                    float: right;
                    line-height: 12px;
                }

                .van-button--small {
                    padding: 0 16px;
                }

                .btn-date {
                    width: 70px;
                    height: 26px;
                    border-radius: 13px;
                    text-align: center;
                    line-height: 26px;
                    font-size: 12px;
                }

                .btn-date--disable {
                    border: 1px solid rgba(71, 56, 56, 0.05);
                    color: rgba(0, 0, 0, 0.45);
                    background: rgba(0, 0, 0, 0.03);

                }

                .date--disable {
                    min-width: 70px;
                    line-height: 26px;
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.45);
                    text-align: center;
                }

                .btn-date--noselect {
                    color: #1496f1;
                    border: 1px solid var(--color-main);
                    background: #ffffff;
                }

                .btn-date--selected {
                    color: #ffffff;
                    background: var(--color-main);
                    border: 1px solid var(--color-main);
                }
            }

            .date-remark {
                padding-bottom: 12px;

                .date-tag {
                    background: rgb(255, 232, 210);
                    color: rgb(201, 74, 1);
                    font-size: 12px;
                    font-weight: 400;
                    padding: 4px;
                    border-radius: 3px;
                }
            }

            // li:last-child {
            //     border: none;
            // }
        }


    }

    .time-range-wrapper {
        padding: 20px 12px;

        .timeRanges {
            // display: flex;
            // flex-wrap: nowrap;
            // justify-content: space-between;
            overflow-x: auto;
            padding: 12px 0;


            .time-item {
                flex: 1;
                font-size: 14px;
                padding: 8px 12px;
                border: 1px solid #fafafa;
                border-radius: 5px;
                // border: 1px solid #cccccc;
                background-color: #fafafa;
                margin: 16px 8px;
                text-align: center;

                p {
                    font-size: 12px;
                    margin-top: 6px;
                    font-weight: 400;
                }
            }

            .time-item--disabled {
                color: #b5b5b5;

                p {
                    color: #b5b5b5;
                }
            }

            .time-item--selected {
                border: 1px solid var(--color-main);
                color: var(--color-main);
                background-color: #f2f8fa;

                p {
                    color: var(--color-main);
                }
            }
        }

        .timeRanges--empty {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 250px;
            text-align: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
        }

        .appoint-time {
            line-height: 32px;
            color: #169bd5;
            margin-bottom: 16px;
        }
    }

    .group-items-wrapper {
        height: 80vh;
        overflow: auto;
        padding: 0 16px;

        .group-items-header {
            text-align: center;
            padding-top: 12px;
        }

        .group-title {
            font-size: 16px;
            font-weight: 600;
            padding: 16px 0 10px 0;
        }

        .item-list {
            padding: 0 16px;

            .item-detail {
                padding: 8px 0;
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);

                .item-name {
                    font-size: 14px;
                    padding-bottom: 4px;
                }

                .item-mean {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.45);
                }
            }
        }
    }
</style>

<script>
    import {
        updateAppointment,
        getSchedule,
        saveAppointment

    } from '@/api/company';
    import {
        async
    } from 'q';
    import moment from 'moment';
    export default {
        data() {
            return {
                selectedIndex: -1,
                orderInfo: undefined,
                schedule: [],
                showTimeRange: false,
                timeRanges: [],
                orderDate: null,
                orderTime: null,
                showGroupItems: false,
                groupItems: [],
            }
        },
        computed: {
            orderDisable: function () {
                return this.selectedIndex < 0;
            },
            hospId: function () {
                return this.$route.query.hospid;
            },
            groupItemsCount: function () {
                if (this.orderInfo && this.orderInfo.groupItems && this.groupItems.length) {
                    return this.orderInfo.groupItems.length;
                } else {
                    return 0;
                }
            }
        },
        methods: {
            selectDate(i, dayItem) {
                this.selectedIndex = i;
                this.orderDate = dayItem;
                this.orderTime = null;
                this.timeRanges = dayItem.timeRanges;
                this.showTimeRange = true;
            },
            setOrderTime(timeRange) {
                if (timeRange.orderable) {
                    this.orderTime = timeRange;
                }
            },
            async submitOrder() {
                if (!this.orderDate || !this.orderTime) {
                    return;
                }
                //2023-10-27 提交预约前判断库存
                let _this = this;
                this.checkScheduleStock().then(flag => {
                    if (!flag) {
                        _this.showTimeRange = false;
                        _this.orderDate = null;
                        _this.orderTime = null;
                        _this.$toast("预约人数可用库存不足，请重新选择");
                        return;
                    }
                    _this.orderInfo.appointDate = _this.orderDate.orderDate;
                    _this.orderInfo.appointTimeRangeId = _this.orderTime.id;
                    _this.orderInfo.appointTimeRangeName = _this.orderTime.name;
                    _this.orderInfo.appointStatus = 1;
                    saveAppointment(_this.orderInfo).then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            _this.$router.push({
                                name: "companyOrderSuccess",
                                params: {
                                    orderinfo: encodeURIComponent(JSON.stringify(_this
                                        .orderInfo))
                                }
                            });
                        } else {
                            _this.$toast(res.msg);
                        }
                    });
                })
            },
            //在提前预约前判断档期库存
            checkScheduleStock() {
                let _this = this;
                return new Promise(function (resolve, reject) {
                    getSchedule(_this.orderInfo).then(res => {
                        let stock = res.data;
                        console.log(stock);
                        console.log(_this.orderDate);
                        let stockItem = stock.find(it => it.orderDate == _this.orderDate.orderDate);
                        if (!stockItem) {
                            _this.schedule = stock;
                            resolve(false)
                        }
                        let stockTimeRange = stockItem.timeRanges.find(it => it.id == _this
                            .orderTime
                            .id);
                        if (!stockTimeRange || stockTimeRange.limitNum == 0 ||
                            stockTimeRange.limitNum <= stockTimeRange.orderNum) {
                            _this.schedule = stock;
                            resolve(false)
                        }
                        resolve(true)
                    });
                })
            }
        },
        created() {
            let hospid = this.$route.query.hospid;
            var appt = JSON.parse(localStorage.getItem("companyAppointment"));
            if (appt == null) {
                this.$router.push('/');
                return;
            }
            this.orderInfo = appt;
            if (this.orderInfo.groupItems && this.orderInfo.groupItems.length > 0) {
                var items0 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 0
                });
                if (items0.length > 0) {
                    this.groupItems.push({
                        title: "一般检查",
                        items: items0
                    })
                }
                var items1 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 1
                });
                if (items1.length > 0) {
                    this.groupItems.push({
                        title: "影像及辅助检查",
                        items: items1
                    })
                }
                var items2 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 2
                });
                if (items2.length > 0) {
                    this.groupItems.push({
                        title: "检验项目",
                        items: items2
                    })
                }
                var items3 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 3
                });
                if (items3.length > 0) {
                    this.groupItems.push({
                        title: "其它项目",
                        items: items3
                    })
                }
            }
            // this.orderInfo = JSON.parse(decodeURIComponent(this.$route.params.orderinfo));
            getSchedule(this.orderInfo).then(res => {
                this.schedule = res.data;
            });
        }
    }
</script>